import React from "react";
interface Tokens {
  setToken: (admin_id_token: string, admin_refresh_token?: string) => void;
  tokens: { admin_id_token: string; admin_refresh_token?: string };
}
export const AuthContext = React.createContext<Tokens>({
  setToken: (admin_id_token: string, admin_refresh_token?: string) => {},
  tokens: { admin_id_token: "" },
});
